import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from 'components/TextField';
import Switch from 'components/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Integration from 'pages/home/KeyFeatures';
import { updateSection } from 'actions/webPages';
import {
  Card,
  CardTitle,
  Row,
  AddSectionButton,
  AddSectionHeader,
  SectionNavbar,
  ThreeBoxWrapper,
  TextFieldWrapperIcon,
} from 'styles/pages/web-pages';

const KeyFeatures = ({ data }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.auth?.profile?.token);
  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    if (data && data?.find((d) => d?.name === 'KEY FEATURES')) {
      const d = data?.find((d) => d?.name === 'KEY FEATURES');
      setBannerData(() => d);
    }
  }, [data]);

  const { components, navVisibility, name } = bannerData || {};
  const { Title = '', BackgroundColor = '', Cards = [] } = components || {};

  return (
    <Card>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999999,
          }}></div>
        <Integration data={bannerData || {}} />
      </div>

      <SectionNavbar>
        <CardTitle style={{ border: 'none' }}>{name}</CardTitle>
        <Switch
          handleChange={(e) =>
            setBannerData({
              ...bannerData,
              navVisibility: e.target.checked,
            })
          }
          checked={navVisibility || false}
        />
      </SectionNavbar>

      <Row>
        <TextField
          label='Background Color'
          size='small'
          value={BackgroundColor}
          onChange={(v) =>
            setBannerData({
              ...bannerData,
              components: {
                ...bannerData.components,
                BackgroundColor: v,
              },
            })
          }
        />
        <TextField
          label='Title'
          size='small'
          value={Title}
          onChange={(v) =>
            setBannerData({
              ...bannerData,
              components: {
                ...bannerData.components,
                Title: v,
              },
            })
          }
        />
      </Row>

      <CardTitle
        style={{
          marginTop: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        Cards Settings
        <AddIcon
          style={{ cursor: 'pointer' }}
          onClick={(v) =>
            setBannerData({
              ...bannerData,
              components: {
                ...bannerData.components,
                Cards: [
                  ...bannerData.components.Cards,
                  { CardTitle: '', CardImage: '', CardSubTitle: '' },
                ],
              },
            })
          }
        />
      </CardTitle>
      <ThreeBoxWrapper>
        {Cards?.map((r, i) => (
          <div key={`button${i}`}>
            <TextFieldWrapperIcon>
              <TextField
                label='Card Title'
                size='small'
                value={r?.CardTitle || ''}
                onChange={(v) =>
                  setBannerData({
                    ...bannerData,
                    components: {
                      ...bannerData.components,
                      Cards: bannerData.components.Cards?.map((b, j) =>
                        i === j ? { ...b, CardTitle: v } : b
                      ),
                    },
                  })
                }
              />
              <DeleteIcon
                className='delete-icon'
                onClick={() =>
                  setBannerData({
                    ...bannerData,
                    components: {
                      ...bannerData.components,
                      Cards: bannerData.components.Cards?.filter(
                        (b, j) => i !== j
                      ),
                    },
                  })
                }
              />
            </TextFieldWrapperIcon>
          </div>
        ))}
      </ThreeBoxWrapper>
      <AddSectionHeader>
        <AddSectionButton
          title='Update'
          onClick={async () => {
            const payload = {
              ...bannerData,
              page: 'LandingPage',
            };

            await dispatch(updateSection({ data: payload, token }));
          }}
        />
      </AddSectionHeader>
    </Card>
  );
};

export default KeyFeatures;
